export default __webpack_public_path__ + "static/media/MelbourneLevel1East_bkup.a5754ac1.jpg";